



















































import Vue from 'vue'
import moment from 'moment'
import { Period } from './../types'

export default Vue.extend({
  name: 'DatePicker',
  props: {
    type: String,
    loading: Boolean
  },
  data () {
    return {
      date: new Date().toISOString().substr(0, 10),
      dates: [
        new Date().toISOString().substr(0, 10),
        new Date().toISOString().substr(0, 10)
      ],
      type$: 'day',
      dateType: 'date',
      menu: false
    }
  },
  computed: {
    computedDateFormatted (): string | string[] | null {
      const date = this.type === 'custom' ? this.dates : this.date
      return this.formatDate(date)
    },
    minMaxDate () {
      return this.type$ === 'custom' && Array.isArray(this.date) && this.date.length === 1
        ? {
            min: moment(this.date[0]).subtract(31, 'd').format('YYYY-MM-DD'),
            max: moment(this.date[0]).add(31, 'd').format('YYYY-MM-DD')
          }
        : { min: null, max: null }
    },
    computePeriod: {
      get (): string | string[] { return this.date },
      set (date: string | string[]): void {
        this.date = Array.isArray(date) && this.type$ !== 'custom'
          ? [
              moment(date[0]).startOf('week').format('YYYY-MM-DD'),
              moment(date[0]).startOf('week').add(6, 'd').format('YYYY-MM-DD')
            ]
          : date
      }
    }
  },
  methods: {
    moveDate (n: string): void {
      const newDate = this.setDateByType(n)
      this.computePeriod = newDate
    },
    setDateByType (n: string): string | string[] {
      switch (this.type) {
        case 'day':
          return moment(this.date).add(n, 'days').format('YYYY-MM-DD')
        case 'week':
          return [moment(this.date[0]).add(n, 'weeks').format('YYYY-MM-DD')]
        case 'month':
          return moment(this.date).add(n, 'months').format('YYYY-MM-DD')
        default:
          return this.date
      }
    },
    formatDate (date: string | string[]): string | string[] | null {
      if (!date) return null

      return Array.isArray(date)
        ? date.map(this.format).join(' / ')
        : this.format(date)
    },
    format (date: string): string {
      const [year, month, day] = date.split('-')
      const dayOrEmptyStr = this.type === 'month' ? '' : `${day}-`
      return `${dayOrEmptyStr}${month}-${year}`
    },
    setDate (date: string): void {
      this.date = date
      this.menu = false
    }
  },
  watch: {
    date (date: string): void {
      this.$emit('change', {
        type: this.type,
        value: date
      })
    },
    dates (dates: string[]): void {
      this.$emit('change', {
        type: this.type,
        value: dates
      })
    },
    type (t: Period): void {
      const index = t === 'month' ? 7 : 10
      const date = new Date().toISOString().substr(0, index)

      this.type$ = 'disable'

      setTimeout(() => {
        this.dateType = t === 'month' ? 'month' : 'date'
        this.date = t === 'week'
          ? [
              moment(date).startOf('week').format('YYYY-MM-DD'),
              moment(date).startOf('week').add(6, 'd').format('YYYY-MM-DD')
            ]
          : date
        this.type$ = t
      }, 500)
    }
  }
})
